import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=7a27bc54&scoped=true&"
import script from "./QuestionHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./question-header.scss?vue&type=style&index=0&id=7a27bc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27bc54",
  null
  
)

export default component.exports